/*
 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
 * http://www.mathgraph32.org/
 * @Author Yves Biton (yves.biton@sesamath.net)
 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
 */

const NatObj = require('./types/NatObj')
const NatCal = require('./types/NatCal')
const Color = require('./types/Color')
const Dimf = require('./types/Dimf')
const InfoProx = require('./types/InfoProx')
const Nat = require('./types/Nat')
const Point = require('./types/Point')
const Pointeur = require('./types/Pointeur')
const kernel = require('./kernel/kernel')
const CListeObjets = require('./objets/CListeObjets')
const CMathGraphDoc = require('./objets/CMathGraphDoc')
const DataInputStream = require('./entreesSorties/DataInputStream')

module.exports = MtgAppLecteur

/**
 * Classe permettant de gérer la création de figures MathGraph32 en JavaScript
 * @constructor
 * @param {boolean} bLoadTextes : true si on doit charger les textes suivant la langue
 * et faux sinon. true par défaut.
 * Lorsqu'une application mtgApp crée une instance de MtgAppLecteur (pour j3p par exemple)
 * il ne faux pas recharger kernel.textes car cela a dékà été fait par mtgApp.
 * @returns {MtgAppLecteur}
 */
function MtgAppLecteur (bLoadTextes) {
  this.docs = [];
  var lt = arguments.length === 0 ? true : bLoadTextes;
  if (lt) {
    const s = kernel.userLan();
    switch (s) {
      case "fr" :
        kernel.textes = require('./textes/textes_fr');
        break;
      case "es" :
        kernel.textes = require('./textes/textes_es');
        break;
      default :
        kernel.textes = require('./textes/textes_en')
    }
  }
}

/*
MtgAppLecteur.prototype.start = function(callBack) {
  if (kernel.textes === undefined) {
    textLoadLecteur.initTextes(callBack);
  }
  else callBack();
}
*/

/**
 * Ajoute le document par son id représenté par une chaîne chdoc en dataBase64
 * @param {String} idDoc : L'id du comument ui sera celle du svg contenant la figure.
 * @param {String} chdoc : Chaine base64 décrivant la figure (obtebue via MathGraph32 par
 * le menu Edition - Copier le code de la figure (pour html)
 * @param {Boolean} displayOnLoad : true si la figure doit être affichée dès le démarrage de la page.
 * @param {Boolean} isActive : true si la figure répond dès le démarrage aux actions souris et clavier.
 * @returns {undefined}
 */
MtgAppLecteur.prototype.addDoc = function(idDoc, chdoc, displayOnLoad, isActive) {
  var svg,liste,li,i,nb,t,la;
  svg = document.getElementById(idDoc);
  if (svg === null) return;
  if (svg.localName !== "svg") return;
  //On rend tous les éléments du div parent non sélectionnables
  const par = svg.parentNode;
  // Ajout version mtgApp. Etait auparavant dans CEditeurFormule
  if (par.style.position === "") par.style.position = "relative";
  //

  // kernel.disableSelection(par);
  par.setAttribute("class","text2jax_ignore"); // Ajout version 5.0.3
  la = arguments.length;
  var doc = new CMathGraphDoc(idDoc, la <= 2 ? true : displayOnLoad, la <= 3 ? true : isActive);
  this.docs.push(doc);
  var ba = kernel.base64Decode(chdoc);
  var inps = new DataInputStream(ba);
  doc.read(inps);
  // Ajout version 4.9.2
  /*
  var r = kernel.cens("rect",{
    width : "100%",
    height : "100%",
    fill : doc.couleurFond.rgb(),
    "pointer-events" : "none"
  });
  svg.appendChild(r);
  // L'image de fond éventuelle doit être affichée après l'éventuel rectangle servant à effacer la figure
  // dans le cas d'une couleur de fond  qui n'est pas blanche
  if (doc.imageFond !== null) {
    var g = kernel.cens("image",{
      x : 0,
      y : 0,
      width : doc.widthImageFond,
      height : doc.heightImageFond,
      "pointer-events" : "none"
    });
    g.setAttributeNS( "http://www.w3.org/1999/xlink", "href", "data:image/png;base64," + kernel.base64Encode(doc.imageFond,true));
    // Modification version 5.1.2 pour que les traces éventuelles recouvrent l'imag de fonf
    // svg.appendChild(g);
    svg.insertBefore(g, doc.gTraces);
  }
  */
  this.prepareTracesEtImageFond(svg, doc);
  liste = new CListeObjets();
  liste.ajoutePointsPunaises(doc.listePrincipale);
  doc.listeARecalculer = new CListeObjets();
  //Spécial JavaScript. Chaque document aura un membre pointCapture
  doc.listeExclusion = liste;
  var winit = parseInt(svg.getAttribute("width"));
  var hinit = parseInt(svg.getAttribute("height"));
  doc.dimf = new Dimf(winit, hinit);
  // On crée un divdestiné à cotenir le svg servant à des affichages auxiliaires
  var divSvgAux = kernel.ce("div", {
    position : "absolute",
    style : "position:absolute;left:0px;top:0px;width:"+winit+"px;height:"+hinit+"px;pointer-events:none"
  });
  par.appendChild(divSvgAux);

  // On modifie si-nécessaire la dimension du svg destiné à afficher provisoirement les affichages de texte
  // Si c'est la première figure, on le crée.
  var svgAux = document.getElementById("mtgSvgAux");
  if (svgAux === null) {
    svgAux = kernel.cens("svg",{
      id : "mtgSvgAux",
      position : "absolute",
      top : 0,
      left : 0,
      width : winit,
      height : hinit,
      visibility : "hidden"
    })
    divSvgAux.appendChild(svgAux);
  }
  else {
    /*
    var w = parseInt(svgAux.getAttribute("width"));
    var h = parseInt(svgAux.getAttribute("height"));
    if (w < winit) svgAux.setAttribute("width", winit);
    if (h < hinit) svgAux.setAttribute("height", hinit);
    */
    svgAux.setAttribute("width", winit);
    svgAux.setAttribute("height", hinit);
  }

  t = this;
  // On mémorise les gestioonaires de souris et de touch pour pouvoir éventuellement les détruire
  this.onmdown = function(evt) {t.onmousedown(evt)};
  this.onmmove = function(evt) {t.onmousemove(evt)};
  this.onmup = function(evt) {t.onmouseup(evt)};
  this.ontstart = function(evt) {t.ontouchstart(evt)};
  this.ontmove = function(evt) {t.ontouchmove(evt)};
  this.ontend = function(evt) {t.ontouchend(evt)};
  this.ontcancel = function(evt) {t.ontouchcancel(evt)};
  svg.addEventListener("mousedown", this.onmdown, false);
  svg.addEventListener("mousemove", this.onmmove, false);
  svg.addEventListener("mouseup", this.onmup, false);
  svg.addEventListener("touchstart", this.ontstart, false);
  svg.addEventListener("touchmove", this.ontmove, false);
  svg.addEventListener("touchend", this.ontend, false);
  svg.addEventListener("touchcancel", this.ontcancel, false);
  // Pour chaque variable associée à un affichage de valeur avec boutons plus et moins on crée un div
  li = doc.listePrincipale;
  nb = 0;
  for (i = li.longueur()-1; i >=0; i--) {
    var el = li.get(i);
    if (el.getNatureCalcul() === NatCal.NVariable) {
      if (el.dialogueAssocie) {
        el.creeDiv(nb);
        nb++;
      }
    }
  }
}

MtgAppLecteur.prototype.prepareTracesEtImageFond = function(svg, doc) {
  var rect = kernel.cens("rect",{
    width : "100%",
    height :  "100%",
    fill : doc.couleurFond.rgb()
  });
  // Ligne suivante importante : Ce rectangle ne doit pas réagir aux événements souris
  // Car sinon il y a problème lors de l'appel de display
  rect.style.pointerEvents = "none";
  svg.appendChild(rect);

  doc.gTraces = kernel.cens("g",{
    id : doc.idDoc + "Traces"
  });
  svg.appendChild(doc.gTraces);
  if (doc.imageFond !== null) {
    var g = kernel.cens("image", {
      x: "0",
      y: "0",
      width: doc.widthImageFond,
      height: doc.heightImageFond
    });
    g.setAttributeNS("http://www.w3.org/1999/xlink", "href", "data:image/png;base64," + kernel.base64Encode(doc.imageFond, true));
    svg.insertBefore(g, doc.gTraces);
  }
}

/**
 * Fonction retirant le document d'id idDoc, retirant les gestionnaires d'événements qui lui sont associés
 * et effaçant touts les éléments graphiques du svg associé
 * @param {String} idDoc : L'id du document à retirer.
 * @returns {undefined}
 */
MtgAppLecteur.prototype.removeDoc = function(idDoc) {
  var svg,liste,ind;
  svg = document.getElementById(idDoc);
  if ((svg !== null) && (svg.localName === "svg")) {
    while (svg.childNodes.length !== 0) svg.removeChild(svg.childNodes[0]);
    svg.removeEventListener("mousedown", this.onmdown, false);
    svg.removeEventListener("mousemove", this.onmmove, false);
    svg.removeEventListener("mouseup", this.onmup, false);
    svg.removeEventListener("touchstart", this.ontstart, false);
    svg.removeEventListener("touchmove", this.ontmove, false);
    svg.removeEventListener("touchend", this.ontend, false);
    svg.removeEventListener("touchcancel", this.ontcancel, false);
  }
  var doc = this.getDoc(idDoc);
  if (doc !== null) {
    liste = doc.listePrincipale;
    if ((svg !== null) && (svg.localName === "svg")) liste.deleteComponents(svg); // Pour retirer les éditeurs et les boutons associés aux variables
    liste.retireTout();
    ind = this.indexOfDoc(idDoc);
    this.docs.splice(ind,1);
  }
};

/**
 * Fonction retirant tous les documents et effaçant le contenu de tous les svg contenant des figures.
 * @returns {undefined}
 */
MtgAppLecteur.prototype.removeAllDoc = function() {
  var nb = this.docs.length;
  for (var i = 0; i < nb; i++) {
    this.removeDoc(this.docs[0].idDoc);
  }
};

/**
 * Fonction recalculant toutes les figures et les affichant.
 * @param {Boolean} brandom : Si true, les calculs aléatoires pas la fonction rand()
 * sont réactualisés.
 * Modifié pour qu'au premier démarrage on charge les textes de la langue utilisée
 * @returns {undefined}
 */
/*
MtgAppLecteur.prototype.calculateAndDisplayAll = function(brandom) {
  if (kernel.textes === undefined) {
    var self = this;
    textLoadLecteur.initTextes(function() {
      self.endCalculateAndDisplayAll(brandom)
    });
  }
  else this.endCalculateAndDisplayAll(brandom);
};
*/
MtgAppLecteur.prototype.calculateAndDisplayAll = function(brandom) {
  var i, j;
  for (i = 0; i < this.docs.length; i++) {
    var doc = this.docs[i];
    var liste = doc.listePrincipale;
    var svg = document.getElementById(doc.idDoc);
    var dimf = new Dimf(parseInt(svg.getAttribute("width")), parseInt(svg.getAttribute("height")));
    this.prepareTracesEtImageFond(svg, doc);
    var macroDem = liste.macroDemarrage;
    if (macroDem !== null) {
      // Ajout version 5.1
      macroDem.setMacroLanceuse(null);
      //
      if (macroDem.className === "CMacroSuiteMacros") {
        for (j = 0; j < macroDem.listeAssociee.longueur(); j++)
          macroDem.listeAssociee.get(j).execute(svg, dimf, doc.couleurFond, doc.opacity,false);
      }
      // Version 4.9.7 : Ajout d'un dernier paramètre pour que la macro ne crée pas d'élements graphiques
      else liste.macroDemarrage.execute(svg, dimf, doc.couleurFond, doc.opacity, false);
    }
    liste.positionne(arguments.length === 0 ? false : brandom, dimf);
    liste.setReady4MathJax();
    MathJax.Hub.Queue([this.callBack,svg,doc]);
  }
}

/**
 * Fonction de callback appelée lorsque MathJax a traité toues les formules
 * en LaTeX et que la figure est prête pour affichage.
 * @param {mtg32.MathGraphDoc} doc : le document à afficher.
 * @param {svg} svg : Le svg contenant la figure.
 * @param {Dimf} dimf : Les diemnsions du svg contenant la figure.
 * @param {Boolean} bDispOnLoad : true si on doit afficher la figure après calculs.
 * @returns {undefined}
 */
MtgAppLecteur.prototype.callBack = function(svg, doc) {
  var liste = doc.listePrincipale;
  liste.afficheTout(0, svg, true, doc.couleurFond, doc.opacity);
};
/**
 * Fonction demandant la validation de tous les éditeurs de formule de la figure associée
 * au document d'id idDoc.
 * Si la formule qu'ils contiennent est incorrecte ils se trouvent encadrés de rouge.
 * Renvoie true uniquement si aucun éditeur de formule ne contient de faute de syntaxe.
 * @param {type} idDoc
 * @returns {Boolean}
 */
MtgAppLecteur.prototype.fieldsValidation = function(idDoc) {
  return this.getDoc(idDoc).listePrincipale.fieldsValidation();
};
/**
 * Fonction renvoyant true si le premier champ d'édition de la figure associée au document d'id idDoc
 * associé au calcul nomCalcul est non vide.
 * @param {String} idDoc : l'id du document contenant la figure interrogée.
 * @param {String} nomCalcul : Le nom du calcul auquel est associé l'éditeur.
 * @returns {unresolved}
 */
MtgAppLecteur.prototype.fieldValidation = function(idDoc, nomCalcul) {
  return this.getDoc(idDoc).listePrincipale.fieldValidation(nomCalcul);
};
/**
 * Fonction renvoyant le contenu du premier éditeur de formule asssocié au calcul nomCalcul
 * dans le dcument d'id idDoc.
 * @param {String} idDoc
 * @param {type} nomCalcul
 * @returns {String}
 */
MtgAppLecteur.prototype.getFieldValue = function(idDoc, nomCalcul) {
  return this.getDoc(idDoc).listePrincipale.getFieldValue(nomCalcul);
};
/**
 * Fonction activant le premier éditeur de formule contenant une
 * formule qui n'est pas correcte sur le plan syntaxique dans le document d'id idDoc.
 * @param {String} idDoc
 * @returns {undefined}
 */
MtgAppLecteur.prototype.activateFirstInvalidField = function(idDoc) {
  this.getDoc(idDoc).listePrincipale.activateFirstInvalidField();
};
/**
 * Fonction activant le premier éditeur de formule vide ou contenant une
 * formule qui n'est pas correcte sur le plan syntaxique dans le document d'id idDoc
 * @param {String} idDoc
 * @returns {unresolved}
 */
MtgAppLecteur.prototype.activateFirstInvalidOrEmptyField = function(idDoc) {
  this.getDoc(idDoc).listePrincipale.activateFirstInvalidOrEmptyField();
};
/**
 * Fonction donnant le focus au premier éditeur de formule qui ne contient rien
 * dans le document d'id idDoc
 * @param {String} idDoc
 * @returns {undefined}
 */
MtgAppLecteur.prototype.activateFirstEmptyField = function(idDoc) {
  this.getDoc(idDoc).listePrincipale.activateFirstEmptyField();
};
/**
 * Fonction donnant le focus au premierr éditeur de formule asscoié au calcul
 * ou à la fonction nommé nomCalcul dans le document d'id idDoc.
 * @param {String} idDoc
 * @param {Srring} nomCalcul
 * @returns {undefined}
 */
MtgAppLecteur.prototype.activateField = function(idDoc, nomCalcul) {
  this.getDoc(idDoc).listePrincipale.activateField(nomCalcul);
};
/**
 * Fonction donnant à l'élément graphique du document d'id idDoc et dont le n° d'identification html est
 * ind la couleur doonée^par les composantes RVB (entiers compris entre 0 et 255)
 * @param {String} idDoc
 * @param {Integer} ind
 * @param {Integer} r : Composante rouge de la couleur (entre 0 et 255).
 * @param {Integer} v : Composante verte de la couleur (entre 0 et 255).
 * @param {Integer} b : Composante bleue de la couleur (entre 0 et 255).
 * @returns {Boolean}
 */
MtgAppLecteur.prototype.setColor = function(idDoc,ind,r,v,b) {
  var color = new Color(r,v,b);
  var doc = this.getDoc(idDoc);
  if (doc === null) return false;
  var liste = doc.listePrincipale;
  var el = liste.getById(ind);
  if (el === null) return false;
  if (!el.estDeNature(NatObj.NTtObj)) return false;
  el.donneCouleur(color);
  var svg = document.getElementById(idDoc);
  MathJax.Hub.Queue([liste.callBack,el,svg,doc.couleurFond,doc.opacity,true]);
};
/**
 * Fonction vidant tous les éditeurs de formule de la figure d'id idDoc
 * @param {String} idDoc
 * @returns {undefined}
 */
MtgAppLecteur.prototype.setEditorsEmpty = function(idDoc) {
  this.getDoc(idDoc).listePrincipale.setEditorsEmpty();
};
/**
 * Fonction mettant dans l'éditeur la chaîne de caractères st et mettant à jour
 * en conséquence l'affichage de formule LaTeX s'il est activé, dans le document d'id idDoc
 * @param {String} idDoc
 * @param {String} nomCalcul
 * @param {String} st
 * @returns {undefined}
 */
MtgAppLecteur.prototype.setEditorValue = function(idDoc, nomCalcul, st) {
  this.getDoc(idDoc).listePrincipale.setEditorValue(nomCalcul, st);
};
/**
 * Fonction attribuant à un éditeur de formule une chaîne de carcatères contenant
 * les caracères autorisés.
 * Si cette chaîne est vide, tous les caractères seront autorisés.
 * @param {type} idDoc
 * @param {type} nomCalcul
 * @param {type} st
 * @returns {undefined}
 */
MtgAppLecteur.prototype.setEditorCharset = function(idDoc, nomCalcul, st) {
  var liste = this.getDoc(idDoc).listePrincipale;
  for (var i = 0; i < liste.longueur(); i++) {
    var elb = liste.get(i);
    if ((elb.getNature() === NatObj.NEditeurFormule) && (elb.calculAssocie.nomCalcul === nomCalcul)) {
      elb.charset = st;
      break;
    }
  }
};
/**
 * Fonction associant, dans le document d'id idDoc, au premier éditeur associé à nomCalcul
 * une fonction de callBack qui sera appelée quand l'utilisateur valide par OK le contenu de l'éditeur.
 * @param {String} idDoc
 * @param {String} nomCalcul
 * @param {function} f : La fonction de callBack
 * @returns {undefined}
 */
MtgAppLecteur.prototype.setEditorCallBackOK = function(idDoc, nomCalcul, f) {
  this.getDoc(idDoc).listePrincipale.setEditorCallBackOK(nomCalcul, f);
};
/**
 * Renvoie la valeur actuelle du calcul réel nommé nomCalcul dans le document d'id idDoc.
 * Renvoie -1 si le calcul n'existe pas.
 * @param {String} idDoc
 * @param {String} nomCalcul
 * @returns {Float}
 */
MtgAppLecteur.prototype.valueOf = function(idDoc, nomCalcul) {
  return this.getDoc(idDoc).listePrincipale.valueOf(nomCalcul);
};
/**
 * Fonction changeant, dans le document d'id idDoc, la formule du calcul ou de
 * la fonction (réelle ou complexe) de nom nomCalcul.
 * La nouvelle formule est contenue dans la chaîne de caractères formule.
 * Renvoie true si la formule était valide et false sinon.
 * @param {String} idDoc
 * @param {String} nomCalcul
 * @param {String} formule
 * @returns {undefined}
 */
MtgAppLecteur.prototype.giveFormula2 = function(idDoc, nomCalcul, formule) {
  var doc = this.getDoc(idDoc);
  if (doc !== null) this.getDoc(idDoc).listePrincipale.giveFormula2(nomCalcul, formule);
};
/**
 * Renvoie la formule en ligne (avec des *) du calcul ou de la fonction nommé nomCalcul
 * contenue dans le document d'id idDoc.
 * @param {String} idDoc
 * @param {String} nomCalcul
 * @returns {String}
 */
MtgAppLecteur.prototype.getFormula = function(idDoc, nomCalcul) {
  var doc = this.getDoc(idDoc);
  if (doc !== null) return this.getDoc(idDoc).listePrincipale.getFormula(nomCalcul);
  return "";
};
// Ajout version 4.9.3
/**
 * Fonction renvoyant la formule LaTeX représentant le calcul ou la fonction
 * dont le nom est nomCalcul dans le document d'id idDoc.
 * @param {String} idDoc
 * @param {String} nomCalcul
 * @returns {String}
 */
MtgAppLecteur.prototype.getLatexFormula = function(idDoc, nomCalcul) {
  var doc = this.getDoc(idDoc);
  if (doc !== null) return this.getDoc(idDoc).listePrincipale.getLatexFormula(nomCalcul);
  return "";
};
/**
 * Fonction donnant à tous les éditeur de formule de la fiure d'id idDoc
 * la taille size.
 * Utilisé dans j3p.
 * @param {String} idDoc
 * @param {String} size
 * @returns {undefined}
 */
MtgAppLecteur.prototype.setEditorsSize = function(idDoc, size) {
  var doc,liste,i,el;
  doc = this.getDoc(idDoc);
  if (doc !== null) {
    liste = this.getDoc(idDoc).listePrincipale;
    for (i=0; i < liste.longueur(); i++) {
      el = liste.get(i);
      if (el.getNature() === NatObj.NEditeurFormule) {
        el.editeur.style.fontSize = size;
        el.latex.x_nom = el.x_nom + el.divi.clientWidth;
        el.latex.y_nom = el.y_nom + el.editeur.clientHeight/2
      }
    }
  }
};
/**
 * Fonction recalculant la figure d'identifiant idDoc
 * @param {String} idDoc
 * @param {String} brandom
 * @returns {undefined}
 */
MtgAppLecteur.prototype.calculate = function(idDoc, brandom) {
  var doc = this.getDoc(idDoc);
  var svg = document.getElementById(idDoc);
  var dimf = new Dimf(parseInt(svg.getAttribute("width")), parseInt(svg.getAttribute("height")));
  if (doc !== null) doc.listePrincipale.positionne(brandom, dimf);
};
/**
 * Fonction affichant la figure d'identifiant idDoc après avoir retiré tous
 * les éléments graphiques du svg de la figure.
 * @param {type} idDoc
 * @returns {undefined}
 */
MtgAppLecteur.prototype.display = function(idDoc) {
  var doc = this.getDoc(idDoc);
  var self = this;
  if (doc !== null) {
    // On retire d'abord tous les enfants du svg
    var liste = doc.listePrincipale;
    var svg = document.getElementById(idDoc);

    MathJax.Hub.Queue(function() {
      while (svg.childNodes.length !== 0) {
        svg.removeChild(svg.childNodes[0]);
      }
      self.prepareTracesEtImageFond(svg, doc);
    });
    liste.setReady4MathJax();
    // MathJax.Hub.Queue(new function() {liste.afficheTout(0, document.getElementById(doc.idDoc), true, doc.couleurFond, doc.opacity)});
    /* Correction version WebPack
    var dimf = new Dimf(parseInt(svg.getAttribute("width")), parseInt(svg.getAttribute("height")));
    MathJax.Hub.Queue([this.callBack,doc,svg,dimf,true]);
    */
    MathJax.Hub.Queue([this.callBack,svg,doc]);
  }
};
/**
 * Fonction mettant à jour les éléments graphiques de la figure d'idDoc.
 * @param {type} idDoc
 * @returns {undefined}
 */
MtgAppLecteur.prototype.updateDisplay = function(idDoc) {
  var doc = this.getDoc(idDoc);
  if (doc !== null) {
    var liste = doc.listePrincipale;
    var svg = document.getElementById(idDoc);
    liste.update(svg, doc.couleurFond, doc.opacity, true);
  }
};
/**
 * Fonction exécutant la macro d'intitulé nameMacro dans la
 * figure d'id idDoc.
 * @param {String} idDoc
 * @param {String} nameMacro
 * @returns {undefined}
 */
MtgAppLecteur.prototype.executeMacro = function(idDoc, nameMacro) {
  var doc = this.getDoc(idDoc);
  if (doc !== null) doc.listePrincipale.executeMacro(nameMacro);
};
/**
 * Renvoie l'indice dlans le tableau this.docs du dooument d'id idDoc.
 * @param {String} idDoc
 * @returns {Integer}
 */
MtgAppLecteur.prototype.indexOfDoc = function(idDoc) {
  for (var i = 0; i < this.docs.length; i++) {
    if(this.docs[i].idDoc === idDoc) return i;
  }
  return -1;
};
/**
 * Renvoie le document d'id idDoc du tableau this.docs.
 * S'il n'y en a pas, renvoie null.
 * @param {String} idDoc
 * @returns {Array}
 */
MtgAppLecteur.prototype.getDoc = function(idDoc) {
  var ind = this.indexOfDoc(idDoc);
  return (ind === -1) ? null : this.docs[ind];
};
/**
 * Renvoie la liste CListeObjets contenant les objets du document d'id idDoc.
 * @param {String} idDoc
 * @returns {Array.listePrincipale}
 */
MtgAppLecteur.prototype.getList = function(idDoc) {
  return this.getDoc(idDoc).listePrincipale;
};
/**
 * Fonction renvoyant le code LaTeX de l'affichage LaTex d'indice ind dans la liste
 * des objets créés (les indices commençant à zéro) dans le document d'id idDoc
 * @param {String} idDoc
 * @param {Integer} ind
 * @returns {String}
 */
MtgAppLecteur.prototype.getLatexCode = function(idDoc, ind) {
  var doc = this.getDoc(idDoc);
  if (doc !== null) return doc.listePrincipale.getLatexCode(ind);
  return "";
};
/**
 * Rend la figure d'id idDoc réactive ou inative aux événements souris et clavier
 * suivant la valeur du boolean ba.
 * @param {String} idDoc
 * @param {Boolean} ba
 * @returns {undefined}
 */
MtgAppLecteur.prototype.setActive = function(idDoc, ba) {
  var doc = this.getDoc(idDoc);
  if (doc !== null) {
    doc.isActive = ba;
    // Il faut aussi activer ou désactiver les champs d'édition de formule
    var liste = doc.listePrincipale;
    for (var i = 0; i < liste.longueur(); i++) {
      var el = liste.get(i);
      if (el.getNature() === NatObj.NEditeurFormule) el.editeur.readOnly = !ba;
      else {
        if (el.getNatureCalcul() === NatCal.NVariable) {
          if (el.dialogueAssocie) {
            el.buttonplus.setAttribute("disabled", !ba);
            el.buttonmoins.setAttribute("disabled", !ba);
            el.buttonegal.setAttribute("disabled", !ba);
          }
        }
      }
    }
  }
};
/**
 * Fonction appelée lors des événements mouseMove sur la figure.
 * @param {event} evt : evt.id conteint l'id de la figure sur laquelle agit l'événement.
 * @returns {undefined}
 */
MtgAppLecteur.prototype.onmousemove = function(evt) {
  var id = evt.target.id;
  var doc = this.getDoc(id);
  doc.hasMouse = true;
  // if (doc.isActive && doc.pointCapture != null) {
  if (doc.isActive) {
    // var th = this;
    // Ligne suivante modifiée version 4.9.9.4 car ralentit beaucoup chrome
    // doc.listePrincipale.heapAddSetTimeOut(function(){th.mousemove(evt, doc)});
    this.mousemove(evt, doc);
    // Ajout version 4.9.2
    if (doc.pointCapture !== null) {
      evt.preventDefault();
      evt.stopPropagation();
    }
  }
};
/**
 * Fonction appelée lors des événements touchMove sur la figure.
 * @param {event} evt : evt.id conteint l'id de la figure sur laquelle agit l'événement.
 * @returns {undefined}
 */
MtgAppLecteur.prototype.ontouchmove = function(evt) {
  var id = evt.target.id;
  var doc = this.getDoc(id);
  if (doc.isActive && (doc.pointCapture !== null)) {
    // var th = this;
    // Ligne suivante modifiée version 4.9.9.4 car ralentit beaucoup chrome
    // doc.listePrincipale.heapAddSetTimeOut(function(){th.touchmove(evt)});
    this.touchmove(evt);
    // A revoir ne sert à rien
    /*
    if (doc.pointCapture !== null) { // Test rajouté version 4.9.9.4
      evt.preventDefault();
      evt.stopPropagation();
    }
    */
  }
};
/**
 * Fonction appelée lors des événements mouseDown sur la figure.
 * @param {event} evt : evt.id contient l'id de la figure sur laquelle agit l'événement.
 * @returns {undefined}
 */
MtgAppLecteur.prototype.onmousedown = function(evt) {
  var mac;
  var id = evt.target.id;
  var svg = document.getElementById((id));
  var doc = this.getDoc(id);
  if (!doc.isActive) return;
  var liste = doc.listePrincipale;
  var dimf = doc.dimf;
  var couleurFond = doc.couleurFond;
  var transp = doc.opacity;
  // Sur les périphériques mobiles il peut y avoir deux événements générés quand on touche l'écran : onmousedown et ontouchstart
  // Abandonné version MtgApp pour qu'on puisse sur PC tactile utiliser mouse et touch
  if (doc.type === "touch") return;
  doc.type = "mouse";
  if (doc.pointCapture !== null) {
    doc.pointCapture = null;
    doc.listeARecalculer.retireTout();
    return;
  }
  if (liste.macroEnCours !== null) {
    mac = liste.macroEnCours.macroEnCours();
    if ((mac.className === "CMacroPause") && (mac.dureePause === 0)) {
      mac.passageMacroSuiv(svg, dimf, couleurFond, transp);
      return;
    }
    if ((mac !== null) && (mac.className === "CMacroApparition") && mac.executionPossible()) {
      mac.execute(svg, dimf, couleurFond, transp, true);
      // Attention mac ne pointe plus forcément sur la macro en cours
      if ((liste.macroEnCours !== null) && !liste.macroEnCours.macroEnCours().executionEnCours)
        liste.macroEnCours.passageMacroSuiv(svg, dimf, couleurFond, transp);
      return;
    }
  }
  var info = new InfoProx();
  var tab = kernel.getMousePosition(evt);
  var par = svg.parentNode;
  var posdiv = kernel.getPosition2(par);
  // var point = new Point(tab[0]-posdiv.x + par.offsetParent.scrollLeft, tab[1]-posdiv.y + par.offsetParent.scrollTop);
  var point = new Point(tab[0]-posdiv[0], tab[1]-posdiv[1]);
  var nbObjetsProches = liste.procheDePourCapture(Nat.or(NatObj.NPointMobile, NatObj.NMacro),
    point, info, doc.listeExclusion, true, "mouse");
  if (nbObjetsProches > 0) {
    if ((mac = info.infoParType[NatObj.indiceMacro].premierVoisin) !== null) {
      if (mac.executionEnCours) {
        mac.macroEnCours().termineAction(svg, dimf, couleurFond, transp);
      }
      else {
        if (liste.macroEnCours !== null) return;
        // liste.deleteTraces(svg);
        if (mac.executionPossible()) { // Ajout version 4.8
          liste.macroEnCours = mac;
          // Ajout version 5.1
          mac.setMacroLanceuse(null);
          //
          mac.initialise();
          mac.execute(svg, dimf, couleurFond, transp, true);
        }
      }
    }
    else {
      if (!liste.documentProprietaire.modeTraceActive) liste.deleteTraces();
      // liste.heapReset(mtg32.heapSizeWeb); // Plus utilisé verion 4.9.9.4
      // doc.pointCapture = info.premierPointVoisin; // Modifi version 4.9.2
      doc.pointCapture = info.dernierPointVoisin;
      doc.listeARecalculer.retireTout();
      doc.listeARecalculer.ajouteObjetsDependantsSauf(doc.pointCapture, doc.listePrincipale, null);
    }
  }
  else {
    if (liste.macroEnCours !== null) {
      if (liste.macroEnCours.className === "CMacroSuiteMacros") {
        mac = liste.macroEnCours.macroEnCours();
        if (mac.arretParClic()) {
          mac.termineAction(svg, dimf, couleurFond, transp);
          liste.macroEnCours.passageMacroSuiv(svg, dimf, couleurFond, transp);
        }
        // passageMacroSuiv redonne éventuellement un ordre paint() suivant la nature de la macro suivante
      }
      else {
        // Si la macro en cours est une macro d'apparition avec clic pour objet suivant
        // on ne la désactive que si on est au dernier objet
        mac = liste.macroEnCours.macroEnCours();
        if ((mac.className === "CMacroApparition") && mac.executionEnCours) {
          // mac.actionDansPaint(cadre);
          // cadre.paneFigure.repaint();
          this.liste.update(svg, couleurFond, transp);
        }
        else {
          if (mac.arretParClic()) {
            mac.termineAction(svg, dimf, couleurFond, transp);
            // this.liste.macroEnCours = null;
          }
        }
      }
    }
  }
};
/**
 * Fonction de callBack appelée lors des événements mouseMove.
 * @param {event} evt : evt.id contient l'id de la figure sur laquelle agit l'événement.
 * @returns {undefined}
 */
MtgAppLecteur.prototype.mousemove = function(evt) {
  var point;
  var id = evt.target.id;
  var svg = document.getElementById(id);
  var doc = this.getDoc(id);
  var tab = kernel.getMousePosition(evt);
  var par = svg.parentNode;
  var posdiv = kernel.getPosition2(par);
  var x = tab[0] - posdiv[0];//  + par.offsetParent.scrollLeft;
  var y = tab[1] - posdiv[1];// + par.offsetParent.scrollTop;
  if (doc.pointCapture === null) {
    var info = new InfoProx();
    point = new Point(x, y);
    var nbObjetsProches =  doc.listePrincipale.procheDePourCapture(NatObj.NPointMobile,
      point, info, doc.listeExclusion, true, "mouse");
    document.body.style.cursor = (nbObjetsProches > 0)? "pointer" : "default";
  }
  else {
    var dimf = doc.dimf;
    var couleurFond = doc.couleurFond;
    var transp = doc.opacity;
    if ((Math.abs(x-doc.pointCapture.x) >= 1) || (Math.abs(y-doc.pointCapture.y) >= 1)) {
      point = new Point();
      var abs = new Pointeur();
      var b = doc.pointCapture.testDeplacement(dimf, x, y, point, abs);
      if (b) {
        if (doc.pointCapture.estDeNature(NatObj.NPointCapturableNonLie)) {
          doc.pointCapture.placeEn(point.x,point.y);
        }
        else if(doc.pointCapture.estDeNature(NatObj.NPointLie)) {
          doc.pointCapture.donneAbscisse(abs.getValue());
        }
      }
      doc.listeARecalculer.positionne(false, dimf);
      doc.listeARecalculer.update(svg, couleurFond, transp, true);
    }
  }
};
/**
 * Fonction de callBack appelée lors des événements mouseUp.
 * @param {event} evt : evt.id contient l'id de la figure sur laquelle agit l'événement.
 * @returns {undefined}
 */
MtgAppLecteur.prototype.ondeviceup = function(evt) {
  var id = evt.target.id;
  var svg = document.getElementById((id));
  var doc = this.getDoc(id);
  if (!doc.isActive) return;
  if (doc.pointCapture !== null) {
    doc.pointCapture = null;
    doc.listeARecalculer.retireTout();
    // Modifié version 5.0.3
    // doc.listePrincipale.update(svg, doc.couleurFond, doc.opacity, true);
    doc.listeARecalculer.update(svg, doc.couleurFond, doc.opacity, true);
    document.body.style.cursor = "default";
  }
};
/**
 * Fonction de callBack appelée lors des événements touchStart.
 * @param {event} evt : evt.id contient l'id de la figure sur laquelle agit l'événement.
 * @param {type} evt
 * @returns {undefined}
 */
MtgAppLecteur.prototype.ontouchstart = function(evt) {
  var mac;
  var id = evt.target.id;
  var svg = document.getElementById((id));
  var doc = this.getDoc(id);
  if (!doc.isActive) return;
  var liste = doc.listePrincipale;
  var dimf = doc.dimf;
  var couleurFond = doc.couleurFond;
  var transp = doc.opacity;
  // Sur les périphériques mobiles il peut y avoir deux événements générés quand on touche l'écran : onmousedown et ontouchstart
  // if (doc.type && (doc.type == "mouse")) return;
  doc.type = "touch";
  if (doc.pointCapture !== null) {
    doc.pointCapture = null;
    doc.listeARecalculer.retireTout();
    return;
  }
  if (liste.macroEnCours !== null) {
    mac = liste.macroEnCours.macroEnCours();
    if ((mac.className === "CMacroPause") && (mac.dureePause === 0)) {
      mac.passageMacroSuiv(svg, dimf, couleurFond, transp);
      return;
    }
    if ((mac !== null) && (mac.className === "CMacroApparition") && mac.executionPossible()) {
      mac.execute(svg, dimf, couleurFond, transp, true);
      // Attention mac ne pointe plus forcément sur la macro en cours
      if (!liste.macroEnCours.macroEnCours().executionEnCours) liste.macroEnCours.passageMacroSuiv(svg, dimf, couleurFond, transp);
      return;
    }
  }
  var info = new InfoProx();
  var tab = kernel.getTouchPosition(evt);
  var par = svg.parentNode;
  // var offs = kernel.getOffset(par); // Version 4.9.9.4 : Ne pas appeler getOffset sur le svg mais sur le div parent
  // Modification version MtgApp car ne marchait plus avec ascenseurs sur mobile
  var offs = kernel.getPosition2(par);
  // var posdiv = kernel.getPosition2(par);
  // var point = new Point(tab[0]-posdiv.x + par.offsetParent.scrollLeft, tab[1]-posdiv.y + par.offsetParent.scrollTop);
  // var point = new Point(tab[0]-par.offsetLeft, tab[1]-par.offsetTop);
  // var point = new Point(tab[0]-offs[0], tab[1]-offs[1]);
  // Modifié version mtgApp
  var point = new Point(tab[0]-offs[0], tab[1]-offs[1]);
  var nbObjetsProches = liste.procheDePourCapture(Nat.or(NatObj.NPointMobile, NatObj.NMacro),
    point, info, doc.listeExclusion, true, "touch");
  if (nbObjetsProches > 0) {
    if ((mac = info.infoParType[NatObj.indiceMacro].premierVoisin) !== null) {
      if (mac.executionEnCours) {
        mac.macroEnCours().termineAction(svg, dimf, couleurFond, transp);

      }
      else {
        if (liste.macroEnCours !== null) return;
        if (!doc.modeTraceActive) liste.deleteTraces();
        liste.macroEnCours = mac;
        mac.initialise();
        mac.execute(svg, dimf, couleurFond, transp, true);
      }
    }
    else {
      if (!doc.modeTraceActive) liste.deleteTraces();
      doc.pointCapture = info.dernierPointVoisin;
      // liste.heapReset(mtg32.heapSizeMobile); // Plus utilisé version 4.9.9.4
      // var ch = evt.target.id.substring(this.liste.id.length);
      // doc.pointCapture = this.liste.get(ch);
      doc.listeARecalculer.retireTout();
      doc.listeARecalculer.ajouteObjetsDependantsSauf(doc.pointCapture, liste, null);
      evt.preventDefault();
      evt.stopPropagation();
    }
  }
  else {
    if (liste.macroEnCours !== null) {
      if (liste.macroEnCours.className === "CMacroSuiteMacros") {
        mac = liste.macroEnCours.macroEnCours();
        if (mac.arretParClic()) {
          mac.termineAction(svg, dimf, couleurFond, transp);
          liste.macroEnCours.passageMacroSuiv(svg, dimf, couleurFond, transp);
        }
        // passageMacroSuiv redonne éventuellement un ordre paint() suivant la nature de la macro suivante
      }
      else {
        // Si la macro en cours est une macro d'apparition avec clic pour objet suivant
        // on ne la désactive que si on est au dernier objet
        mac = liste.macroEnCours.macroEnCours();
        if ((mac.className === "CMacroApparition") && mac.executionEnCours) {
          // mac.actionDansPaint(cadre);
          // cadre.paneFigure.repaint();
          liste.update(svg, couleurFond, transp);
        }
        else {
          if (mac.arretParClic()) {
            mac.termineAction(svg, dimf, couleurFond, transp);
            // this.liste.macroEnCours = null;
          }
        }
      }
    }
  }
};
/**
 * Fonction de callBack appelée lors des événements touchMove.
 * @param {event} evt : evt.id contient l'id de la figure sur laquelle agit l'événement.
 * @returns {undefined}
 */
MtgAppLecteur.prototype.touchmove = function(evt) {
  var id = evt.target.id;
  var svg = document.getElementById(id);
  var doc = this.getDoc(id);
  if (doc.pointCapture !== null) {
    var dimf = doc.dimf;
    var couleurFond = doc.couleurFond;
    var transp = doc.opacity;
    var tab = kernel.getTouchPosition(evt);
    var par = svg.parentNode;
    // var offs = kernel.getOffset(par); // Version 4.9.9.4 : Ne pas appeler getOffset sur le svg mais sur le div parent
    // Modification version MtgApp car ne marchait plus avec ascenseurs sur mobile
    var offs = kernel.getPosition2(par);
    // var posdiv = kernel.getPosition2(par);
    // var x = tab[0] - par.offsetLeft; // + par.offsetParent.scrollLeft;
    // var y = tab[1] - par.offsetTop; // + par.offsetParent.scrollTop;
    // var x = tab[0] - offs[0]; // + par.offsetParent.scrollLeft;
    // var y = tab[1] - offs[1]; // + par.offsetParent.scrollTop;
    // Modifié version mtgApp
    var x = tab[0] - offs[0]; // + par.offsetParent.scrollLeft;
    var y = tab[1] - offs[1]; // + par.offsetParent.scrollTop;

    if ((Math.abs(x-doc.pointCapture.x) >= 1) || (Math.abs(y-doc.pointCapture.y) >= 1)) {
      var point = new Point();
      var abs = new Pointeur();
      var b = doc.pointCapture.testDeplacement(dimf, x, y, point, abs);
      if (b) {
        if (doc.pointCapture.estDeNature(Nat.or(NatObj.NPointBase, NatObj.NPointBaseEnt,
            NatObj.NPointInterieurCercle, NatObj.NPointInterieurPolygone))) {
          doc.pointCapture.placeEn(point.x,point.y);
        }
        else if(doc.pointCapture.estDeNature(NatObj.NPointLie)) {
          doc.pointCapture.donneAbscisse(abs.getValue());
        }
      }
      doc.listeARecalculer.positionne(false, dimf);
      doc.listeARecalculer.update(svg, couleurFond, transp, true);
    }
  }
};
/**
 * Fonction de callBack appelée lors des événements touchEnd.
 * @param {event} evt : evt.id contient l'id de la figure sur laquelle agit l'événement.
 * @returns {undefined}
 */
MtgAppLecteur.prototype.ontouchend = function(evt) {
  /*
  var id = evt.target.id;
  var doc = this.getDoc(id);
  doc.type = ""; // On autorise à nouveau tous les événements
  */
  this.ondeviceup(evt);
};
/**
 * Fonction de callBack appelée lors des événements touchCancel.
 * @param {event} evt : evt.id contient l'id de la figure sur laquelle agit l'événement.
 * @returns {undefined}
 */
MtgAppLecteur.prototype.ontouchcancel = function(evt) {
  this.ondeviceup(evt);
};

// Quand il y a à la fois des éléments mouse et touch générés, les événements touch sont toujours en premier
// et les mouse en derniers
// On met doc.type à "" pour autoriser à nouveau tous les types d'événements sur un mouseup
MtgAppLecteur.prototype.onmouseup = function(evt) {
  this.ondeviceup(evt);
  var id = evt.target.id;
  var doc = this.getDoc(id);
  doc.type = ""; // On autorise à nouveau tous les événements
}
// Ajout version 4.9.7.
// Renvoie un objet de type CListeObjets créé à partir d'une chaîne base64 d'une figure.
// Sert à gérer des objets de type calcul sans gérer une figure
/**
 * Renvoie un objet de type CListeObjets créé à partir d'une chaîne base64 d'une figure.
 * Sert à gérer des objets de type calcul sans gérer une figure.
 * @param {String} code : Le code Base64 de la figure obtenu dans mtg32 par
 * Edition - Copier le code de la figure.
 * @returns {CListeObjets}
 */
MtgAppLecteur.prototype.createList = function(code) {
  var doc = new CMathGraphDoc(null,false,false);
  var ba = kernel.base64Decode(code);
  var inps = new DataInputStream(ba);
  doc.read(inps);
  return doc.listePrincipale;
};



// WEBPACK FOOTER //
// ./src/MtgAppLecteur.js